/**
 * Check if Telegram WebApp version supports a specific feature
 * @param minVersion - Minimum required version (e.g., 6.1)
 * @returns true if current version is equal or higher than minVersion
 */
export const isTelegramVersionSupported = (minVersion: number): boolean => {
  const tg = window.Telegram.WebApp
  if (!tg) {
    return false
  }

  const currentVersion = parseFloat(tg.version || '0')
  return currentVersion >= minVersion
}

/**
 * Check if the app is running inside Telegram Mini App
 * @returns true if running in Telegram, false if in regular browser
 */
export const isInTelegram = (): boolean => {
  const tg = window.Telegram.WebApp
  if (!tg) {
    return false
  }

  // initData is only populated when running inside Telegram
  return Boolean(tg.initData)
}

/**
 * Check if the app is running on a mobile device (iOS or Android)
 * @returns true if running on mobile Telegram client
 */
export const isMobilePlatform = (): boolean => {
  const tg = window.Telegram.WebApp
  if (!tg) {
    return false
  }

  const mobilePlatforms = ['android', 'ios', 'android_x', 'ios_x']
  return mobilePlatforms.includes(tg.platform)
}

export const useTelegram = () => {
  const tg = window.Telegram.WebApp

  return {
    tg,
    isTelegramVersionSupported,
    isInTelegram,
  }
}
